/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Filter_ArchivedInputs */



/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Projects_Filter_ArchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_filter_archived = /** @type {((inputs?: Projects_Filter_ArchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Filter_ArchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Archiviert")
	return /** @type {LocalizedString} */ ("Archived")
});